module.exports = __webpack_public_path__ + "static/media/phone_scroll_1.b7a526b7.png";